import React from 'react';
import './animatedBackground.css';

const AnimatedBackground = () => {
  return (
    <div className="ripple-background">
      <div className="ripple-1"></div>
      <div className="ripple-2"></div>
      <div className="ripple-3"></div>
      <div className="ripple-4"></div>
      <div className="ripple-5"></div>
    </div>
  );
};

export default AnimatedBackground;
